// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3eBMN","content":"styles_content__7zBOp","tableWrap":"styles_tableWrap__1Z0yW"};